import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, skip } from 'rxjs/operators';

@Directive({
    selector: '[ngModelChangeDebounced]'
})
export class NgModelChangeDebouncedDirective implements OnInit, OnDestroy {
    @Output() ngModelChangeDebounced = new EventEmitter<any>();
    @Input() ngModelChangeDebounceTime = 500;

    private subscription: Subscription;

    constructor(private ngModel: NgModel) {
    }

    ngOnInit(): void {
        // Set up here instead of the constructor, so ngModelChangeDebounceTime can be overridden.
        this.subscription = this.ngModel.control.valueChanges.pipe(
            skip(1), // skip first (initial value)
            distinctUntilChanged(),
            debounceTime(this.ngModelChangeDebounceTime)
        ).subscribe(value => this.ngModelChangeDebounced.emit(value));
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }
}
